import { registerSystem } from "yage/components/ComponentRegistry";
import { System } from "yage/components/System";
import { PlayerTypeSchema, EnemyTypeSchema } from "yage/components/entity/Types";
import { Component, Schema, defaultValue, type } from "yage/decorators/type";
import { GameModel } from "yage/game/GameModel";
import { ChildSchema } from "yage/schemas/entity/Child";
import { getPlayerCharacter } from "../../utils/playerCharacter";

@Component("ShareOnLevelUp")
export class ShareOnLevelUpSchema extends Schema {
  @type(["number"])
  @defaultValue([])
  entities: number[];

  @type("number")
  @defaultValue(-1)
  owner: number;
}

class ShareOnLevelUpSystem implements System {
  schema = ShareOnLevelUpSchema;
  type = "ShareOnLevelUp";
  dependencies = ["Child"];

  init(entity: number, gameModel: GameModel) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      let parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      if (gameModel.hasComponent(parent, "PlayerInput")) {
        parent = getPlayerCharacter(parent, gameModel);
      }
      gameModel.addIfMissing(parent, ShareOnLevelUpSchema);
      const parentData = gameModel.getTypedUnsafe(parent, ShareOnLevelUpSchema);
      parentData.entities.push(entity);
    }
  }
}

registerSystem(ShareOnLevelUpSystem);
